import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { differenceInCalendarDays, isValid } from 'date-fns';
import ReportFilterActions, { ReportFilterActionsProps } from './ReportFilters/ReportFilterActions';

import {
  reportFilterCountryCodeSelector,
  reportFilterStartAccountingDateSelector,
  reportFilterEndAccountingDateSelector,
  reportHeaderLimitDaysSelector,
  reportFilterStoresSelector,
} from '../state';

import DateRangeLimitModal from './Modals/DateRangeLimitModal';

const ConciliationHeaderFilterActions = ({ children }: ReportFilterActionsProps) => {
  const countryCode = useSelector(reportFilterCountryCodeSelector);
  const startDate = useSelector(reportFilterStartAccountingDateSelector);
  const endDate = useSelector(reportFilterEndAccountingDateSelector);
  const headerLimitDays = useSelector(reportHeaderLimitDaysSelector);
  const selectedStores = useSelector(reportFilterStoresSelector);

  const isTooLarge = useMemo(() => {
    const storesCount = selectedStores?.length || 0;
    const isMassiveSearch = storesCount === 0 || storesCount > 10;

    if (!isMassiveSearch) return false;

    const start = startDate?.accept;
    const end = endDate?.accept;
    if (!start || !end) return false;
    if (!isValid(start) || !isValid(end)) return false;
    const days = differenceInCalendarDays(end, start) + 1;
    return days > headerLimitDays;
  }, [startDate, endDate, headerLimitDays, selectedStores]);

  const baseDisabled = !(startDate.accept && endDate.accept && countryCode);
  const applyDisabled = baseDisabled;

  const [modalOpen, setModalOpen] = useState(false);

  const beforeApply = () => {
    if (!isTooLarge) return true;
    setModalOpen(true);
    return false;
  };

  return (
    <>
      <DateRangeLimitModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxDays={headerLimitDays}
      />

      <ReportFilterActions applyDisabled={applyDisabled} beforeApply={beforeApply}>
        {children}
      </ReportFilterActions>
    </>
  );
};

export default ConciliationHeaderFilterActions;
